import React from 'react';
import { Breadcrumbs } from 'baseui/breadcrumbs';
import { IDummyProps } from './types';
import { overrides as customOverrides } from './overrides';
import { mergeOverrides } from 'baseui';

export const View = React.forwardRef((props: IDummyProps, ref: any) => {
	const { overrides, ...rest } = props;

	return (
		<Breadcrumbs
			ref={ref}
			overrides={overrides ? mergeOverrides(customOverrides(props), overrides as any) : customOverrides(props)}
			{...rest}
		/>
	);
});
